import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Internet drama",
  "description": "",
  "published": "2007-06-27T00:00:00.000Z",
  "redirect_from": ["/blog/internet-drama/swizec/181"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Internet je velik in je obširen, predvsem pa je nepredstavljivo ogromen. Danes si bomo ogledali zelo zanimiv del Å¾ivljenja na internetu - dramo. Zakaj pravzaprav obstaja in zakaj vraga je vsaj pribliÅ¾no prenašana?`}</p>
    <p>{`Niti pribliÅ¾no se mi ne sanja, lahko pa povem kaj o njej. Veliko ljudi se zelo potopi v spletne skupnosti, kar je dobro, zelo dobro celo, ampak gre lahko malÄek predaleÄ. Na primer, ko ljudje za dalj Äasa odidejo in se potem vrnejo, navadno obelodanijo svojo vrnitev širši javnosti in skušajo povzroÄiti veliko pompa. To niti ni tako slabo, omogoÄi jim vpogled v stanje starih prijateljstev in jih prijetno poÅ¾geÄka globoko nekje, ko se jih kdo spomni ... vsekakor predvsem pozitivno.`}</p>
    <p>{`Prav nadleÅ¾ni so v bistvu tisti, ki se odloÄijo javno oznaniti svoj odhod in skušajo to dejanje poveliÄevati. Skoraj kot "Poglejte me! Odhajam, ker vas ne maram, sedaj pa jokajte za mano in me prosite, da ostanem, Äeprav pravim, da ne bom nikoli veÄ pogledal teh strani ..." PrviÄ, zakaj bi rabil temo, ki je ne nameravaš nikoli veÄ pogledati? DrugiÄ, zakaj bi nas moralo skrbeti, da smo te izgubili? OÄitno nas ne maraš in mi verjetno ne maramo tebe.`}</p>
    <p>{`Forum, na katerega zadnje Äase pogosto zahajam, se pravkar grize skozi nekaj podobnega. Nekdo je bil popolna baraba na IRC kanalu, ali pa so take vsaj govorice, in bilo je celo tako grozno, da je uboga admin-punÄara izdavila, da sovraÅ¾i IRC in jo opomnilo zakaj v bistvu sploh sovraÅ¾i ljudi ... tja se veÄ ne vrne. Ta osebek je bil banan, potem pa je priplesal na forum in oznanil, da zapušÄa forum za vekomaj in da je blokiral vsakogar na MSNju, ki je imel kaj veze s forumom. Bravo, super zate gospod oseba, zakaj Å¾e nam to govoriš? Smo razvajeno otroÄe kaj?`}</p>
    <p>{`Na kratko, ne delaj internetne drame, ker potem izgledaš kot razvajen dvanajst letnik.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      